var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 36,
    viewBox: "0 0 21 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.197 35.2076C20.7111 34.7 21 34.0118 21 33.2941C21 32.5765 20.7111 31.8882 20.197 31.3806L6.62039 17.9837L20.197 4.58667C20.6966 4.07623 20.973 3.39257 20.9668 2.68295C20.9605 1.97332 20.6721 1.2945 20.1636 0.792702C19.655 0.290905 18.9671 0.00627159 18.248 0.000103214C17.5288 -0.00606134 16.836 0.266735 16.3187 0.759739L0.803038 16.0702C0.288853 16.5777 2.23401e-07 17.266 2.14843e-07 17.9837C2.06285e-07 18.7013 0.288853 19.3896 0.803038 19.8971L16.3187 35.2076C16.8331 35.715 17.5306 36 18.2578 36C18.9851 36 19.6826 35.715 20.197 35.2076Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.13243012f096210e7d996b602a2e66e1.svg";
export { ForwardRef as ReactComponent };